import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { ReturnDeliveryDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ReturnDeliveryDto } from 'src/app/shared/models/return-delivery/return-delivery-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ReturnDeliveryWorkItem extends WorkItem<ReturnDeliveryDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'ReturnDeliveryWorkItem';
  }
  get database(): string {
    return ReturnDeliveryDB;
  }
}
